import {
  DeleteTemporaryMediaItemRequest,
  SharedMediaApi,
  UploadTemporaryMediaItemRequest
} from '@DigitaleDoerfer/digitale-doerfer-api';
import { useCallback, useMemo } from 'react';
import { handleError } from 'utils';
import { useGetDDServiceApiConfiguration } from './dd.service';

export const useSharedMediaApi = () => {
  const configuration = useGetDDServiceApiConfiguration();
  const apiInstance = useMemo(
    () => new SharedMediaApi(configuration),
    [configuration]
  );

  const uploadTemporaryMediaItem = useCallback(
    (requestParameters: UploadTemporaryMediaItemRequest) =>
      apiInstance
        .uploadTemporaryMediaItem(requestParameters)
        .catch(handleError),
    [apiInstance]
  );

  const deleteTemporaryMediaItem = useCallback(
    (requestParameters: DeleteTemporaryMediaItemRequest) =>
      apiInstance
        .deleteTemporaryMediaItem(requestParameters)
        .catch(handleError),
    [apiInstance]
  );

  return {
    uploadTemporaryMediaItem,
    deleteTemporaryMediaItem
  };
};
